import { useTranslation } from 'react-i18next';
import { api } from '../api/client';
import { usePaginated } from '../lib/hooks';
import { useLang } from '../lib/useLang';
import { formatDateTime } from '../lib/format';
import { PageHeader } from '../components/PageHeader';
import { ApiState, EmptyState } from '../components/States';
import { LoadMore } from '../components/Pagination';
import { Badge, Card } from '../components/ui';
import { IconAudit } from '../components/Icons';

const PAGE = 40;

export function Audit() {
  const { t } = useTranslation();
  const lang = useLang();
  const list = usePaginated((cursor) => api.listAudit(PAGE, cursor), []);

  return (
    <>
      <PageHeader title={t('audit.title')} subtitle={t('audit.subtitle')} />
      <Card>
        <ApiState status={list.status} error={list.error} data={list.status === 'error' ? null : list.items} onRetry={list.reload}>
          {(items) =>
            items.length === 0 ? (
              <EmptyState title={t('audit.empty')} icon={<IconAudit width={26} height={26} />} />
            ) : (
              <>
                <div className="table-wrap">
                  <table className="data">
                    <thead>
                      <tr>
                        <th className="num">{t('audit.colSeq')}</th>
                        <th>{t('audit.colTime')}</th>
                        <th>{t('audit.colActor')}</th>
                        <th>{t('audit.colAction')}</th>
                        <th>{t('audit.colResource')}</th>
                        <th>{t('audit.colResult')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((e) => (
                        <tr key={e.seq}>
                          <td className="num mono muted">{e.seq}</td>
                          <td className="muted" style={{ whiteSpace: 'nowrap' }}>
                            {formatDateTime(e.occurredAt, lang)}
                          </td>
                          <td>{e.actor}</td>
                          <td className="cell-strong">{e.action}</td>
                          <td className="mono">{e.resource}</td>
                          <td>
                            <Badge tone={e.result === 'OK' ? 'success' : e.result === 'DENY' || e.result === 'ERROR' ? 'danger' : 'default'}>
                              {e.result}
                            </Badge>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <LoadMore hasMore={list.hasMore} loading={list.loadingMore} onLoadMore={list.loadMore} />
              </>
            )
          }
        </ApiState>
      </Card>
    </>
  );
}
